import React from 'react'
import { SlotCounter } from './Components/SlotCounter'

type AnimatedNumberTransitionProps = {
  separatorCharacters?: string
  dummyCharacters?: string[]
} & ({ start: string; end: string } | { start?: never; end: string })

export const AnimatedNumberTransition = React.memo<AnimatedNumberTransitionProps>(
  ({ start, end, separatorCharacters, dummyCharacters }) => {
    return (
      <SlotCounter
        speed={1}
        startValue={start}
        value={end}
        dummyCharacters={dummyCharacters}
        separatorCharacters={separatorCharacters ? separatorCharacters.split('') : undefined}
      />
    )
  }
)
AnimatedNumberTransition.displayName = 'AnimatedNumberTransition'
